var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStepArrow = function SvgStepArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "140px",
    height: "145px",
    viewBox: "0 0 140 145",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "route_graphic")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI_Cashy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01_Homepage",
    transform: "translate(-714.000000, -2852.000000)",
    stroke: "#000000",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "How_it_Works",
    transform: "translate(304.000000, 2768.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "route_graphic",
    transform: "translate(411.000000, 86.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.73046875,0.1484375 C10.9648438,34.0494792 26.5426432,62.960612 50.4638672,86.8818359 C74.3850911,110.80306 103.296224,126.380859 137.197266,133.615234",
    id: "Path-12-Copy-2",
    transform: "translate(70.463867, 66.881836) scale(-1, 1) translate(-70.463867, -66.881836) "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-22",
    transform: "translate(11.500000, 133.333333) rotate(134.000000) translate(-11.500000, -133.333333) ",
    points: "4 141.666667 19 139.840271 14.6421465 125"
  })))))));
};
export default SvgStepArrow;